<template>
  <div class="flex-col">
    <v-tooltip :color="this.thumbnailURL ? 'orange' : 'base'" bottom dark class="margin-auto">
      <a class="base--text flex-row" slot="activator">
        <div class="thumbnail" :class="{'cursor-not-allowed': !this.hasC2C}">
          <img v-if="this.thumbnailURL" :src="this.thumbnailURL" />

          <v-icon v-else class="ml-1 mt-1" :color="skin.primary_color" x-large>
            no_photography
          </v-icon>
        </div>

        <i v-if="!this.hasC2C" class="material-icons link_off"></i>
      </a>

      <span>
        {{
            this.hasC2C
              ? this.thumbnailURL
                ? 'Mostrar'
                : 'Foto no disponible'
              : 'C2C no disponible'
        }}
      </span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    thumbnailURL: {
      type: [String, Boolean],
      required: true
    },
    hasC2C: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState({
      skin: state => state.settings.skin
    })
  }
}
</script>

<style lang="stylus" scoped>
.base--text{
  width: 84px;
}

.link_off{
  color: #bbb;
}

.thumbnail{
    display: block;
    margin: 5px;
    background-color: var(--v-secondary-lighten2);
    border: 1px solid var(--v-secondary-base);
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    width: 50px;
    height: 50px;
}

.thumbnail img{
  width: 100%;
  height: 100%
}

.thumbnail i{
  font-size: 3.4rem;
  color: var(--v-primary-base)
}
</style>